import React, { PureComponent } from 'react';
import '../../../styles/StartingScreen/BuyCryptoCard.css';
import { toDollarSmall } from '../../../helpers/helperFunctions';
// import { motion, AnimatePresence } from 'framer-motion';

class BuyCryptoCard extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      startIdx: 0,
      direction: 1,
      windowCoins: []
    };
  }

  componentDidMount() {
    this.setState({
      windowCoins: this.getWindow(0)
    }, () => {
      // Only create the cycling interval if we have more than 7 unique coins
      if (this.getUniqueCoins().length > 7) {
        this.startInterval();
      }
    });
  }

  componentDidUpdate(prevProps) {
    // If the coins prop changes, update the window and (re)start / stop the interval accordingly
    if (prevProps.coins !== this.props.coins) {
      this.setState({ windowCoins: this.getWindow(this.state.startIdx) });

      // Handle transition from <=7 to >7 unique coins
      if (this.getUniqueCoins(prevProps.coins).length <= 7 && this.getUniqueCoins().length > 7) {
        this.startInterval();
      }

      // Handle transition from >7 to <=7 unique coins
      if (this.getUniqueCoins(prevProps.coins).length > 7 && this.getUniqueCoins().length <= 7) {
        clearInterval(this.interval);
      }
    }
  }

  startInterval() {
    // Clear any existing interval before starting a new one
    if (this.interval) clearInterval(this.interval);

    this.interval = setInterval(() => {
      // Guard against having 7 or fewer unique coins after interval has been started
      if (this.getUniqueCoins().length <= 7) return;

      this.setState((prevState) => {
        const nextStartIdx = (prevState.startIdx + 1) % (this.getUniqueCoins().length - 1);
        return {
          startIdx: nextStartIdx,
          windowCoins: this.getWindow(nextStartIdx)
        };
      });
    }, 5000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  getUniqueCoins(coinsList = this.props.coins) {
    const seen = new Set();
    return coinsList.filter((coin) => {
      const ticker = (coin.ticker || '').toUpperCase();
      if (seen.has(ticker)) return false;
      seen.add(ticker);
      return true;
    });
  }

  getWindow(startIdx = this.state.startIdx) {
    const uniqueCoins = this.getUniqueCoins();
    if (uniqueCoins.length <= 7) return uniqueCoins;
    const btc = uniqueCoins[0];
    const rest = uniqueCoins.slice(1);
    const window = [];
    for (let i = 0; i < 6; i++) {
      window.push(rest[(startIdx + i) % rest.length]);
    }
    return [btc, ...window];
  }

  render() {
    const { rates, onClick } = this.props;
    const uniqueCoins = this.getUniqueCoins();
    const { windowCoins } = this.state;
  
  if (uniqueCoins.length > 1) {
    return (
      <div className='buy-crypto-card' onClick={onClick}>
        <div className={
            `buy-crypto-card-coins-container
            ${uniqueCoins.length == 2 ? 'less-than-2-coins-container' : ''}
            ${uniqueCoins.length <= 3 ? 'less-than-3-coins-container' : ''}`
            }>
          {windowCoins.map((coin) => (
            <div
              className={`buy-crypto-card-coin ${uniqueCoins.length > 3 && coin.ticker === 'BTC' ? 'btc-coin-card' : ''}`}
              key={coin.ticker}
            >
              <img className='buy-crypto-card-coin-logo' src={`/assets/coins/${coin.ticker.toUpperCase()}.png`} alt={coin.name} />
              <div className='buy-crypto-card-coin-info'>
                <h1 className='buy-crypto-card-coin-ticker'>{coin.ticker.toUpperCase()}</h1>
                <h1 className='buy-crypto-card-coin-price'>{rates[coin.name.toLowerCase()] ? toDollarSmall(rates[coin.name.toLowerCase()].price) : null}</h1>
              </div>
            </div>
          ))}
        </div>
        <div className={`buy-crypto-card-header ${uniqueCoins.length == 2 ? 'buy-crypto-card-header-2-coins' : ''}`}>
          <h1 className='buy-crypto-card-header-title'>Crypto</h1>
        </div>
        <div className='buy-crypto-card-footer'>
          <div className='buy-crypto-card-footer-option'>Buy</div>
          {/* <div className='buy-crypto-card-footer-option'>Sell</div> */}
        </div>
      </div>
      );
  }
  return (
    <div className='buy-crypto-card btc-alone' onClick={onClick}>
      <img className='buy-crypto-card-coin-logo' src={`/assets/coins/BTC.png`} />
      <h1 className='buy-crypto-card-coin-price'>${rates['bitcoin'] ? toDollarSmall(rates['bitcoin'].price) : null}</h1>
      <div className='buy-crypto-card-header'>
        <h1 className='buy-crypto-card-header-title'>Crypto</h1>
      </div>
      <div className='buy-crypto-card-footer'>
        <div className='buy-crypto-card-footer-option'>Buy</div>
        {/* <div className='buy-crypto-card-footer-option'>Sell</div> */}
      </div>
    </div>
  );
  }
}

export default BuyCryptoCard;